module.exports = __webpack_public_path__ + "static/media/sliderPersonal.700857c4.jpg";